// ConfirmModal.jsx ☑️ Unified custom modal
import React from "react";
import { Modal } from "react-bootstrap";
import "./styles/ConfirmModal.css"; // 🆕 match your design

export default function ConfirmModal({ show, onConfirm, onCancel, title = "Confirm", message = "Are you sure?" }) {
  return (
    <Modal show={show} onHide={onCancel} centered dialogClassName="custom-mfa-modal">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn-profile" onClick={onCancel}>Cancel</button>
        <button className="btn-profile btn-danger" onClick={onConfirm}>Yes, Continue</button>
      </Modal.Footer>
    </Modal>
  );
}
